module.exports = __webpack_public_path__ + "img/nanotube.86519df3.png";